import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import http from 'Arch/services/HttpService';

export default class ReportsRequest extends CrudRequest {
  static baseUrl() {
    return 'reports/reports';
  }

  static solicit(payload = {}) {
    return http.post(
      `${this.baseUrl()}/statement`,
      payload,
    );
  }

  static report(fileName) {
    return http.get(`backofficeapi/files/s3url/${fileName}`);
  }
}
